import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import _ from 'lodash';
import * as actions from '../../actions/user';
import ContainerTranslation from "../partials/ContainerTranslation";

import UserList from './UserList';

class User extends React.Component {

  constructor(props) {
    super(props);
    const { fetchUsers } = this.props;
    fetchUsers();
    this.clientRole = JSON.parse(localStorage.getItem("user")).role
    this.endpoint = localStorage.getItem('endpoint') ? localStorage.getItem('endpoint') : "";
  }

  fetchUsersList = () => {
    this.props.getExportUsersList()
  }

  renderUsers() {
    var _this = this
    if (this.props.users && this.props.users.length) {

      return (
        <div>
          <div>
            <UserList displayUsers={_.filter(_this.props.users, function(user){
              return  (user.sageContent.role === "" || 
                          !user.sageContent.role || 
                           (user.sageContent.role === "Ingeneer" || user.sageContent.role === "Director") ||
                          (user.sageContent.manager === "" && (user.sageContent.role !== "DirectorGeneral" || user.sageContent.role !== "AssociatedDirector" ) ) || 
                          (!user.sageContent.manager && (user.sageContent.role !== "DirectorGeneral" || user.sageContent.role !== "AssociatedDirector" )) || 
                          !user.sageContent.filiale.city || 
                          user.sageContent.filiale.city === "")
              })} title="Member to solve" 
            />
          </div>
          <div>
            {
              this.endpoint === "aegis" ? 
              <>
                <UserList displayUsers={_.filter(_this.props.users, function(user){return  user.sageContent.role === "Admin" || user.sageContent.role === "SuperAdmin"})} title="administrators" />
                <UserList displayUsers={_.filter(_this.props.users, function(user){return  user.sageContent.role === "Employee"})} title="Employee" />
                <UserList displayUsers={_.filter(_this.props.users, function(user){return  user.sageContent.role === "Associate"})} title="Associate" />
              </>
              :
              <>
                <UserList displayUsers={_.filter(_this.props.users, function(user){return  user.isProjectManager})} title="project managers" /><br/>
                <UserList displayUsers={_.filter(_this.props.users, function(user){return  user.sageContent.role === "Admin" || user.sageContent.role === "SuperAdmin"})} title="administrators" />
                <UserList displayUsers={_.filter(_this.props.users, function(user){return  user.sageContent.role === "DirectorGeneral"})} title="general directors" />
                <UserList displayUsers={_.filter(_this.props.users, function(user){return  user.sageContent.role === "AssociateDirector"})} title="associated directors" />
                <UserList displayUsers={_.filter(_this.props.users, function(user){return  user.sageContent.role === "RH"})} title="RH" />
                <UserList displayUsers={_.filter(_this.props.users, function(user){return  user.sageContent.role === "BusinessUnitManager"})} title="business unit managers" />
                <UserList displayUsers={_.filter(_this.props.users, function(user){return  user.sageContent.role === "Manager"})} title="managers" />
                <UserList displayUsers={_.filter(_this.props.users, function(user){return  user.sageContent.role === "BusinessDeveloper"})} title="business developers" />
                <UserList displayUsers={_.filter(_this.props.users, function(user){return  user.sageContent.role === "Ingeneer"})} title="ingeneers" />
                <UserList displayUsers={_.filter(_this.props.users, function(user){return  user.sageContent.role === "Member" && (user.sageContent.manager || user.sageContent.manager === "")})} title="consultants" />
              </>
            }
          </div>
        </div>
      );
    }
  }

    render() {
      if (Object.keys(this.props.users).length === 0 || !this.props.authorization) {
      return null
    }
    
    return (
      <div>
        <h1 className="page-title">{this.props.users.length} <ContainerTranslation id={'Page.User.title'} /></h1>
          {this.props.authorization.create ? 
            <>
            <Link to="/createuser" style={{float:"right"}}><button className="primary-btn"><ContainerTranslation id={'Page.User.btn-add'} /></button></Link>
            <button
                className="primary-btn"
                onClick={() => this.fetchUsersList()}
                style={{float: "right", marginRight: "20px"}}>
                <ContainerTranslation id={'Export.Users'} />
            </button>
            </>
            :
            null
          }
          {/* {this.props.export && this.state.loadUsersList? <ExportExcel dataToExcel={this.props.export} exportType={"Users"}/> : null } */}

        {!this.props.users || !this.props.users.length ? (
          <div style={{left:'40%',right:'40%',top:'40%', bottom:'40%', display:'flex', position:'absolute', justifyContent:'center', alignItems:'center', flexDirection:'column'}}>
            <i className="fa fa-circle-notch fa-spin fa-3x" style={{color: '#eb4f1e'}}></i>
            <p style={{color:"#fff", marginTop:"10px", textAlign:'center'}}>Receiving users ...</p>
          </div>
        ) : (
          null
        )}

        <div className="page-container">
          {this.renderUsers()}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    users: state.user.users,
    export: state.user.export,
    authorization: state.user.authorization
  };
}

export default connect(mapStateToProps, actions)(User);
